import BreakpointOnly from "./BreakpointOnly";
import Swiper from 'swiper/bundle';

export default class MobileSlider extends BreakpointOnly{
  constructor(breakpoint, el, options)
  {
    super(breakpoint);
    this.el = document.querySelector(el);
    this.options = options;
    this.slider = undefined;
    this.breakpointChecker();
  }

  enableSlider()
  {
    this.slider = new Swiper( this.el, this.options );
  }

  mayBeDestroySlider()
  {
    if( this.slider !== undefined  ) {
      this.slider.destroy(true, true);
    }
  }

  breakpointChecker()
  {
    if ( this.breakpoint.matches === true ) {
      this.mayBeDestroySlider();
    } else {
      this.enableSlider();
    }
  }
}
